import gif from "@/assets/graduate.gif";

export default function GradCapLoader() {
  return (
    <div className="p-8 w-full relative flex items-center justify-center">
      <img src={gif} className="w-36 h-36 object-cover rounded-full" />
    </div>
  );
}
